// Shared classes for Radix dropdown menus in the shell.
export const menuContentClass =
  'st-animate-fade z-50 min-w-64 rounded-lg border border-border bg-surface p-1 text-text shadow-card';
export const menuItemClass =
  'flex min-h-11 cursor-pointer items-center gap-3 rounded-md px-3 outline-none select-none data-[highlighted]:bg-primary-soft data-[highlighted]:text-primary';
